const initImageCarousel = () => {
    const carousels = document.querySelectorAll('.Banner');

    carousels.forEach((carousel) => {
        const slides = carousel.querySelectorAll('.Banner--slide');
        const controls = carousel.querySelectorAll('.Banner--controls-item');

        console.log(slides, controls);

        if(slides.length < 2) {
            return;
        }

        let currentIndex = 0;

        controls.forEach((control, index) => {
            control.addEventListener('click', () => {
                close(slides[currentIndex]);
                controls[currentIndex].classList.remove('Active');

                currentIndex = index;

                controls[currentIndex].classList.add('Active');
                open(slides[currentIndex]);
            });
        });
    });

    function open(slide){
        slide.classList.add('Active');
        slide.classList.remove("LastActive");
    }

    function close(slide){
        slide.classList.remove('Active');
        slide.classList.add("LastActive");
        setTimeout(() => {
            slide.classList.remove("LastActive");
        }, 500);
    }
}

initImageCarousel();